import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'kind': 'String!',
	'building_guid': 'String!',
	'floor_guid': 'String!',
	'room_guid': 'String',
	'timeslot_guid': 'String!',
	'transport_kind': 'String',
	'building_parking_space_guid': 'String',
	'booking_date': '[String]',
	'active': '[String]',
};

export default gql(`
	query timeslot_capacity( ${ HelperGraphql.createFields( fields ) } ) {
		employee_bookings( ${ HelperGraphql.createVariables( fields ) } ) {
			guid
			
			employee {
				guid
				name
			}
		}
	}
`);

